import React from 'react';
import { withRouter } from 'react-router-dom'
import Card from 'react-bootstrap/Card';
import classes from './NavigationItem.css'

const navigationItem = (props) => {

  let cardClasses = 'navigation-item ' + (props.selected ? 'selected ' : '');

  return (
    <Card className={cardClasses}
    onClick={() => {
      props.history.push(props.itemPath);
      props.setContentPath(props.itemIndex);
    }}
    onMouseEnter={() => props.setAccordionKeys([...props.itemIndex].reverse().splice(1).reverse())}>
      <p>{props.name}</p>
    </Card>
  )
};

export default withRouter(navigationItem)
